import { starterVenues } from "./catalog";
/** Only recognized coordinates are proposed; the user confirms before opening. */
export function parseTicketText(text: string) {
	const venue =
		starterVenues.find((venue) =>
			[
				venue.name,
				...venue.spaces.flatMap((s) => [s.name, ...(s.aliases ?? [])]),
			].some((name) => text.includes(name)),
		) ??
		starterVenues.find((venue) =>
			text.includes(venue.name.split(" ")[0] ?? venue.name),
		);
	const section =
		text.match(/((?:\d층\s*)?[A-Z가-힣]+구역|\d층)/i)?.[1] ?? null;
	const row = text.match(/([A-Z]|\d+)\s*열/i)?.[1] ?? null;
	const number = text.match(/(?:열\s*)(\d+)\s*번?/i)?.[1];
	const space = venue?.spaces.find((space) =>
		[space.name, ...(space.aliases ?? [])].some((name) => text.includes(name)),
	);
	return {
		venueId: venue?.id ?? null,
		spaceId: space?.id ?? null,
		sectionCode: section,
		rowLabel: row,
		seatNumber: number ? Number(number) : null,
	};
}
